<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-6 add-title">
            <div class="form-group m-label-left">
              <input v-model="title" type="text" id="title" class="form-control" />
              <label for="title">Title</label>
            </div>
            <div class="form-group m-label-left">
              <input v-model="url" type="text" id="url" class="form-control" />
              <label for="url">Page name</label>
            </div>
            <div class="form-group m-label-left">
              <select v-model="category" id="category" class="form-control">
                <option>Back-end Developers</option>
                <option>Front-end Developers</option>
                <option>Mobile App Developers</option>
                <option>Cloud Developers</option>
                <option>Other Roles</option>
              </select>
              <label for="category">Category</label>
            </div>

            <div class="form-group m-label-left filter-item">
              <v-select
                @search="onCompetenceSearch"
                label="name"
                v-model="competences"
                :options="[...getCompetencesFilterList]"
                :reduce="comp => comp.id"
                :clearable="true"
                multiple
                id="add-job-competences"
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching && search.length >= 3">
                    No results found for <em>{{ search }}</em
                    >.
                  </template>
                  <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                </template>
              </v-select>
              <label for="competences">Related competencies</label>
            </div>

            <div class="form-group">
              <h5 style="font-weight: 700!important;  font-size: 16px!important;">Intro text</h5>
              <TextEditorIntro v-model="intro" />
            </div>

            <div class="form-group">
              <h5 style="font-weight: 700!important;  font-size: 16px!important;">Body text</h5>
              <TextEditorTitle v-model="text" />
            </div>

            <div class="d-flex">
              <button @click="createTitle" class="btn btn-primary ml-auto mr-2">Save</button>
              <button @click="cancelTitle" class="btn btn-secondary mr-2">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />

    <!--    <div
      class="modal fade add-user-modal"
      id="deleteCampaignModal"
      tabindex="-1"
      aria-labelledby="deleteCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteCampaignModalTitle">Delete Campaign</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p class="text-center">
                  Please confirm that you want to delete <strong>{{ editCampaignId }}.</strong> This
                  action will permanently delete the information.
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="deleteCampaign()" type="button" class="btn btn-primary">
              Delete
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';
import TextEditorTitle from '../../common/TextEditorTitle.vue';
import TextEditorIntro from '../../common/TextEditorIntro.vue';

export default {
  mixins: [titleMixin],
  props: {
    itemToEdit: Object,
  },
  title() {
    return 'Website | Jobshark';
  },
  /*   description() {
        return 'Page description goes here.';
      }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/website';
  },
  components: {
    TextEditorTitle,
    TextEditorIntro,
  },
  data: () => ({
    isLoading: false,
    title: '',
    url: '',
    category: '',
    competences: [],
    intro: '',
    text: `
<h2>What does a [job title] do?</h2>
<p>A [job title] plays a crucial role in designing, developing, and maintaining Java-based applications that are often core components of large-scale enterprise systems, web applications, and mobile platforms. Their work typically involves writing clean, efficient, scalable code using Java and its associated frameworks like Spring, Hibernate, and Struts.</p>

<p>In addition to coding, [job title]s are responsible for debugging, optimizing, and ensuring the performance and security of applications. They often collaborate with other developers, project managers, and stakeholders to gather requirements, participate in code reviews, and contribute to the full software development lifecycle (SDLC).</p>

<p>[job title]s may also handle backend development, integrating databases like MySQL, PostgreSQL, or NoSQL solutions, and ensuring seamless data flow and functionality. With the growing demand for cloud-based solutions, [job title]s increasingly work with cloud services like AWS, Google Cloud, or Azure to deploy, scale, and manage applications.</p>

<p>Whether in an Agile team or as part of DevOps practices, a [job title]’s work is both collaborative and technical, focusing on delivering robust and secure applications.</p>

<h2>How to hire [job title]s: a quick guide</h2>
<h3>Define your requirements</h3>
<p>Before starting your search, clearly define the skills and experience you need. Are you looking for Java backend developers, full-stack [job title]s, or experts in Java frameworks like Spring Boot, Hibernate, or Struts? Outline the specific technical requirements, such as proficiency in Java 8+, JVM tuning, multithreading, and RESTful API development. If your project involves databases, ensure the developer has experience with SQL, NoSQL, and ORM frameworks.</p>

<h3>Where to find [job title]s</h3>
<p>There are several platforms where you can hire top-tier [job title]s. Job boards like LinkedIn, Indeed, Jobshark, and Glassdoor are excellent starting points. Additionally, platforms like Toptal, Jobshark, Upwork, and Fiverr offer access to freelance [job title]s. Attending Java conferences or engaging with open-source Java projects on GitHub can also help you find talent actively working in the Java ecosystem. For quicker hiring, partnering with tech sourcing companies, like Jobshark, can help streamline the process.</p>

<h3>Assess technical skills</h3>
<p>Evaluating technical expertise is crucial when hiring a [job title]. Use Java coding tests or coding platforms like DevSkiller, Codility, HackerRank, or LeetCode to assess problem-solving skills. In interviews, dive deep into core Java concepts like Object-Oriented Programming (OOP), data structures, and design patterns. Ask about experience with popular Java frameworks like Spring, Hibernate, or JavaServer Faces (JSF), as well as tools such as Maven, Gradle, and version control systems like Git.</p>

<h3>Evaluate soft skills and cultural fit</h3>
<p>While technical proficiency is key, it’s equally important to hire [job title]s who are a good cultural fit. Strong communication skills and the ability to work in remote teams are crucial, especially if your team operates remotely. Look for developers with experience in Agile or Scrum methodologies who are adaptable and thrive in collaborative environments. Their ability to communicate effectively and work well with others will ensure smoother development cycles.</p>

<h2>A brief history of Java</h2>
<p>Java was developed by James Gosling and his team at Sun Microsystems (now part of Oracle) in 1995. Initially intended for interactive television, Java quickly evolved into a general-purpose programming language with the slogan “write once, run anywhere” (WORA). This capability, thanks to the Java Virtual Machine (JVM), allowed Java applications to run on any device or platform, making it a breakthrough in cross-platform software development. In 1996, Java 1.0 was released, gaining popularity for web development with the rise of Java applets. Over the years, Java expanded beyond web development to power enterprise applications, mobile devices, and large-scale systems. The language’s growth was fueled by regular updates and a growing ecosystem, solidifying its position as one of the most widely used programming languages globally.</p>

<h2>Popular Java frameworks</h2>
<ul>
  <li><strong>Spring:</strong> A comprehensive framework for building enterprise-level applications. Spring’s modular architecture supports web, data access, and security development, with Spring Boot simplifying the creation of stand-alone applications.</li>
  <li><strong>Hibernate:</strong> An Object-Relational Mapping (ORM) framework that simplifies database interactions by mapping Java objects to database tables, making it easier to manage data persistence.</li>
  <li><strong>JavaServer Faces (JSF):</strong> A Java-based web framework for developing server-side applications. It simplifies building user interfaces for Java web applications by integrating with various UI component libraries.</li>
  <li><strong>Struts:</strong> An older but still widely used framework for building enterprise-level Java web applications. Struts follows the Model-View-Controller (MVC) architecture, making it easier to maintain and scale applications.</li>
  <li><strong>Vaadin:</strong> A modern framework for building rich web applications in Java. Vaadin allows developers to create interactive UIs without relying on JavaScript or HTML.</li>
</ul>

<h2>Key benefits of Java</h2>
<ul>
  <li><strong>Platform independence:</strong> Thanks to the JVM, Java applications can run on any device or operating system that supports Java, making it highly portable.</li>
  <li><strong>Rich ecosystem:</strong> Java boasts a vast collection of libraries, frameworks, and tools, making it suitable for everything from web and mobile development to large-scale enterprise systems.</li>
  <li><strong>High performance and scalability:</strong> With robust memory management, garbage collection, and concurrency features, Java is ideal for large applications requiring high performance and scalability.</li>
  <li><strong>Strong community and support:</strong> Java has a vast and active community of developers and regular updates from Oracle, ensuring that the language remains modern and secure.</li>
  <li><strong>Security:</strong> Built with security in mind, Java provides features such as bytecode verification, security managers, and APIs for cryptography and authentication, making it a trusted choice for secure applications.</li>
</ul>
`,
  }),
  methods: {
    ...mapActions(['retrieveCompetencesList']),

    createTitle() {
      if (this.itemToEdit === null) {
        axios(`${process.env.VUE_APP_API_URL}/admin/website/create`, {
          method: 'post',
          data: {
            title: this.title,
            intro_text: this.intro,
            text: this.text,
            page_name: this.url,
            category: this.category,
            competences: this.competences,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(res => {
            this.$emit('cancel');
          })
          .catch(() => {
            this.$toasted.error('There was error while trying to add new title.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        axios(`${process.env.VUE_APP_API_URL}/admin/website/update`, {
          method: 'post',
          data: {
            id: this.itemToEdit.id,
            title: this.title,
            intro_text: this.intro,
            text: this.text,
            page_name: this.url,
            category: this.category,
            competences: this.competences,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).then(res => {
          this.$emit('cancel');
        });
      }
    },

    cancelTitle() {
      this.$emit('cancel');
    },

    onCompetenceSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.competencesOptions = this.getCompetencesFilterList;
      }

      loading(false);
    },
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getCompetencesFilterList']),
  },
  mounted() {
    this.retrieveCompetencesList();
    if (this.itemToEdit !== null) {
      this.intro = this.itemToEdit.intro_text;
      this.title = this.itemToEdit.title;
      this.url = this.itemToEdit.page_name;
      this.category = this.itemToEdit.category;
      this.competences = this.itemToEdit.competences;
      this.text = this.itemToEdit.text;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.add-title {
  padding: 20px 12px;
  h3 {
    color: red !important;
  }

  h4 {
    color: red !important;
  }
}
</style>
